export default import.meta.ROLLUP_FILE_URL_LPA5Nfd_xg8nAYYwZKX8dQ